export const azimuthStats = [
  { n: '86.3%', l: 'recall on EVMBench Detect (101/117)' },
  { n: '#1', l: 'on Nethermind’s AgentArena' },
  { n: '79 min', l: 'to find a critical flaw in Ledger’s Ethereum app' }
];
